/** Composition root: the shell does not import feature modules; only this layer wires them. */
import { createPuntosEntregaRoute } from '@src/modules/puntos_entrega/infrastructure/drivers/page/puntosEntregaRoute.ts';
import { createRedencionBonoRoute } from '@src/modules/redencion_bono/infrastructure/drivers/page/redencionBonoRoute.ts';
import { createSyncRoute } from '@src/modules/sync/infrastructure/drivers/page/syncRoute.ts';
import { createObservabilidadRoute } from '@src/modules/observabilidad/infrastructure/drivers/page/observabilidadRoute.ts';
import type { ShellAuthApplicationPort } from '@src/modules/shared/app-context/domain/ports/ShellAuthApplicationPort.ts';
import type { ShellNavigationPort } from '@src/modules/shared/app-context/domain/ports/ShellNavigationPort.ts';
import type { PresentationShellPort } from '@src/modules/shared/presentation/application/ports/PresentationShellPort.ts';
import type { CoreShellPorts } from '@src/modules/shared/routing/domain/CoreShellPorts.ts';
import type { ShellRouteBinding } from '@src/modules/shared/routing/domain/ShellRouteBinding.ts';
import { createDashboardRoute } from '@src/modules/shared/routing/infrastructure/drivers/routes/dashboardRoute.ts';

/** Builds the routing configuration array for the application shell. */
export function buildShellRouteBindings<T extends CoreShellPorts>(
  auth: ShellAuthApplicationPort,
  navigation: ShellNavigationPort,
  presentation: PresentationShellPort,
  shellPorts: T,
): ShellRouteBinding[] {
  return [
    { path: '/login', handler: () => presentation.mountLoginInApp(shellPorts) },
    { path: '/', handler: createDashboardRoute(auth, navigation, presentation, shellPorts) },
    { path: '/puntos-entrega', handler: createPuntosEntregaRoute(auth, navigation, presentation, shellPorts) },
    { path: '/redencion-bono', handler: createRedencionBonoRoute(auth, navigation, presentation, shellPorts) },
    { path: '/sync', handler: createSyncRoute(auth, navigation, presentation, shellPorts) },
    {
      path: '/observabilidad',
      handler: createObservabilidadRoute(auth, navigation, presentation, shellPorts),
    },
  ];
}
